<template>
  <div>
    <div>
      <b-card-body>
        <b-card class="importContainer">
          <b-form @submit.stop.prevent="onSave">
            <b-form-group :label="$t('escolha-cab')" label-for="headerText">
              <b-form-input class="custom-select-color" id="headerText" v-model="localHeader.text"
                :placeholder="$t('digiteOTitulo')"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('cor-de-fundo')">
              <div class="color-radio-group">
                <label v-for="opt in colorOptions" :key="opt.value"
                  :class="['color-option', { selected: localHeader.color === opt.value }]"
                  :style="{ backgroundColor: opt.value }">
                  <input type="radio" v-model="localHeader.color" :value="opt.value" />
                  {{ opt.label }}
                </label>
              </div>
            </b-form-group>
            <b-row class="groupBtn">
              <div class="modal-buttons">
                <img width="30" height="30" class="action-btn" src="@/assets/salvar.png" :title="$t('salvar')"
                  @click="onSave" />
                <img width="30" height="30" class="action-btn exit-btn" src="@/assets/sair.png" :title="$t('cancelar')"
                  @click="$emit('close')" />
              </div>
            </b-row>
          </b-form>
        </b-card>
      </b-card-body>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderModal",
  props: {
    header: {
      type: Object,
      default: () => ({ text: "", color: "gray" })
    },
    colorOptions: {
      type: Array,
      default: () => [
        { value: "#000000", label: "Preto" },
        { value: "#26806c", label: "Verde" },
        { value: "#70297A", label: "Roxo" },
        { value: "#254E70", label: "Azul" },
        { value: "#808080", label: "Cinza" },
        { value: "#bf0603", label: "Vermelho" },
        { value: "#f6ae2d", label: "Amarelo" },
        { value: "#e85933", label: "Laranja" }
      ]
    }
  },
  data() {
    return {
      localHeader: { ...this.header }
    };
  },
  methods: {
    onSave() {
      // Emite o evento com os dados atualizados para o componente pai
      this.$emit("save", { ...this.localHeader });
    }
  },
  watch: {
    header(newVal) {
      this.localHeader = { ...newVal };
    }
  }
};
</script>

<style scoped>
/* Estilos para o campo de escolha das cores */
.color-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.color-option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  font-weight: 500;
  transition: transform 0.2s, box-shadow 0.2s;
}

/* Espaço entre o input e o label */
.color-option input[type="radio"] {
  margin-right: 8px;
}

/* Efeito hover para realce */
.color-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

/* Destaque para a opção selecionada com o tom de verde #009a9b */
.color-option.selected {
  border: 2px solid #009a9b;
  box-shadow: none;
}

/* Demais estilos mantidos do componente */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 400px;
  box-sizing: border-box;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ccc;
  padding: 10px;
  margin: -20px -20px 20px -20px;
  text-align: center;
}

.modal-buttons {
  cursor: pointer;
  margin-top: 20px;
  text-align: right;
}

.exit-btn {
  margin-left: 14px;
  margin-right: 14px;
}

.custom-select-color:focus {
  border-color: #009a9a !important;
  box-shadow: 0 0 0 0.2rem rgba(0,154,154,0.25) !important;
}

.custom-select-color {
  border: 1px solid #009a9a !important;
  border-radius: 4px;
  padding: 5px;
  font-size: 16px;
}
</style>
